import { InjectionToken } from '@angular/core';
import type { CanvasConfig } from './canvas.interface';

export const CANVAS_CONFIG = new InjectionToken<CanvasConfig>('CanvasConfig');
